export class PortalApp {
  public id: string;
  public label: string;
  public shortLabel: string;
  public description: string;
  private readonly iconActiveUri: string;
  private readonly iconInactiveUri: string;
  public active: boolean;
  public mobileApp: boolean;
  public desktopApp: boolean;

  public get logoUri(): string {
    return this.active ? this.iconActiveUri : this.iconInactiveUri;
  }

  constructor(
    id: string,
    label: string,
    shortLabel: string,
    description: string,
    iconActive: string,
    iconInactive: string,
    active: boolean
  ) {
    this.id = id;
    this.label = label;
    this.shortLabel = shortLabel;
    this.description = description;
    this.iconActiveUri = iconActive;
    this.iconInactiveUri = iconInactive;
    this.active = active;
  }

  public setMode(mode: '1'|'2'|'3') {
    this.desktopApp = mode !== '2';
    this.mobileApp = mode !== '1';
  }
}
